export const SortOptionsEnum = {
  rfmTier: 'rfmTier',
  roomType: 'roomType',
  lastName: 'lastName',
  membershipTier: 'membershipTier',
  vipTier: 'vipTier',
} as const;
export type SortOptionsType =
  (typeof SortOptionsEnum)[keyof typeof SortOptionsEnum];

export const SortDirectionEnum = {
  asc: 'asc',
  desc: 'desc',
} as const;
export type SortDirectionType =
  (typeof SortDirectionEnum)[keyof typeof SortDirectionEnum];
